import $ from "../libs/jquery-3.3.1.min.js"
import {BaseGameMyst} from "./base/BaseGameMyst";
import {MystQuete} from "./MystQuete";
import {AudioPlaylist} from '/js/app/base/AudioPlaylist.js'
import {gsap, SplitText} from "../libs/gsap/all.js";
import {MystMQTT} from "./MystMQTT";
import {Howl} from "howler";
import nunjucks from "/js/libs/nunjucks.js"

// Constructor
export class MystRemise extends MystQuete {

  constructor(remiseId) {

    // Super constructor
    super(`remise`);

    // Save remiseId
    this.remiseId = remiseId;

    // Archetype data
    this.archetypeData = {archetype: 5, inventory: []};

    this.completedCount = 0;
    this.rewardWidthMulti = 0.03;
    // Limit how small reward can become
    // Only allow downsizing up to 47.5% of themselves
    this.rewardMinWidthPerc = 0.475;
  }

  // Init nunjucks
  initMQTT() {
    this.data.base_station_rfid = `RFID-${this.remiseId}`
    this.data.mqtt_topic = this.data.mqtt_topic.replace("[remiseId]", this.remiseId);
    super.initMQTT();
  }

  onMessage(e) {

    // Override station state
    const baseStationRFID = this.data.base_station_rfid;
    let progressCount = 0;
    for (let i = 0; i < e.scanData.progress.length; i++) {
      if (e.scanData.progress[i].station === baseStationRFID) {
        e.scanData.progress[i].state = "idle";
      } else if (e.scanData.progress[i].state && e.scanData.progress[i].state != "idle") {
        progressCount++;
      }
    }

    // Override userSwitch value to prevent loop when tag is left on scanner and visit is completed
    if (e.scanData.userSwitch === true && progressCount == 0) {
      e.scanData.userSwitch = false;
      console.log("It's a new visitor, but progress is empty. Ignore scan.")
    }

    super.onMessage(e);
    if (e.scanData) this.archetypeData = this.getArchetypeData(e.scanData);
  }

  // disable spoken text
  initSpokenTexts() {
  }

  // To be overridden in child games
  initGame() {
    super.initGame();
  }

  updateArchetypeAndInventory() {
    console.log("archetype", this.archetypeData.archetype);
    console.log("inventory", this.archetypeData.inventory);

    if (this.archetypeData) {
      this.completedCount = this.archetypeData.inventory.length ?? 0;

      // Update current user archetype
      $("#main").removeClass("archetype-0 archetype-1 archetype-2 archetype-3 archetype-4 archetype-5")
        .addClass("archetype-" + this.archetypeData.archetype);

      // Add inventory elements
      const $grid = $(".bag .wrapper");
      $grid.find(".grid-item").remove();

      // Prepare rewards
      for (let i = 0; i < this.completedCount; i++) {
        const reward = this.archetypeData.inventory[i];
        const rewardImage = typeof reward.image.media === "string" ? reward.image.media : reward.image.media[this.i18n.lang];

        // Append img
        $grid.append(`<div class="grid-item"><img src='${rewardImage}' class='reward'/></div>`)
      }

      // Calculate grid size
      const gridColumn = Math.ceil(this.completedCount / Math.floor(Math.sqrt(this.completedCount)));
      const gridRow = Math.ceil(this.completedCount / gridColumn);

      // Ensure columns are always greater than rows
      if (gridColumn < gridRow) {
        [gridRow, gridColumn] = [gridColumn, gridRow]; // Swap if needed
      }

      $grid.addClass("grid-row-" + gridRow);
      $grid.addClass("grid-column-" + gridColumn);
    }
  }

  /**
   * Find archetype for given scan data.
   * @param scanData
   * @returns {{archetype: (number), inventory: *[]}}
   */
  getArchetypeData(scanData) {

    let totalCount = 0;
    const groupCompletedCount = [
      {"group_id": "1", "group_count": 0, rewards: []},
      {"group_id": "2", "group_count": 0, rewards: []},
      {"group_id": "3", "group_count": 0, rewards: []},
      {"group_id": "4", "group_count": 0, rewards: []}
    ];

    this.data.global.bag.rewards.forEach((reward) => {
      const rewardRfid = BaseGameMyst.getStationRFID(reward.quete_id);
      const rewardQueteCompleted = ["completed"].includes(BaseGameMyst.findStationScanData(rewardRfid, scanData));
      const groupIndex = reward.group_id - 1;
      if (rewardQueteCompleted && groupCompletedCount[groupIndex]) {
        groupCompletedCount[groupIndex].group_count++;
        groupCompletedCount[groupIndex].rewards.push(reward);
        totalCount++;
      }
    });

    groupCompletedCount.sort((a, b) => b.group_count - a.group_count);
    const hasEquality = (groupCompletedCount[0].group_count === groupCompletedCount[1].group_count);
    const hasNoReward = totalCount === 0;

    // Define archetype type
    let archetypeId;
    if (hasNoReward) archetypeId = 0;
    else if (hasEquality) archetypeId = 5;
    else archetypeId = Number.parseInt(groupCompletedCount[0].group_id);

    return {
      archetype: archetypeId,
      inventory: groupCompletedCount.reduce((acc, group) => acc.concat(group.rewards), []),
    }
  }

  animateInContent($screenEl, previousScreenType) {
    super.animateInContent($screenEl, previousScreenType)

    // Perso
    this.currentTimeline.to("#perso", {
      alpha: 1,
      duration: 0.75,
      ease: "power2.inOut"
    }, 0);
  }

  /**
   * Animate IN IDLE screen
   * @param $screenEl
   */
  animateInIdle($screenEl) {

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    this.currentTimeline.fromTo($screenEl.find(".container"), {
      alpha: 0.0,
      y: -180
    }, {
      alpha: 1.0,
      y: 0,
      duration: 0.60,
      ease: "power1.inOut"
    });

    // Perso
    this.currentTimeline.to("#perso", {
      alpha: 1,
      duration: 0.75,
      ease: "power2.inOut"
    }, "<=");

  }

  /**
   * Animate OUT IDLE screen
   * @param screenDestinationId
   */
  animateOutIdle(screenDestinationId) {
    const $screenEl = $("#screen-1");

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    $screenEl.removeClass("current");

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Hide content
    this.currentTimeline.to($screenEl.find(".container"), {
      y: 180,
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    });

    // End by going to new screen
    this.currentTimeline.add(() => {
      // Allow screen change
      this.unlockCurrentScreen();
      this.goToScreen(screenDestinationId);
    });
  }

  /**
   * Animate IN Remise Archetype screen
   * @param screenDestinationId
   */
  animateInRemiseArchetype($screenEl, previousScreenType) {

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    const hidePerson = typeof $screenEl.data("hide-person") !== "undefined" ? $screenEl.data("hide-person") : false;
    if (hidePerson === true) {
      this.currentTimeline.to("#perso", {
        alpha: 0.0,
        duration: 0.75,
        ease: "power1.inOut"
      }, '<=');
    }

    this.currentTimeline.add(() => this.updateArchetypeAndInventory())

    // Show background
    this.currentTimeline.fromTo($("#background-overlay"), {
      alpha: 0.0
    }, {
      alpha: 1.0,
      duration: 0.75,
      ease: "power2.inOut"
    });

    this.currentTimeline.fromTo($screenEl.find(".container, .bag"), {
      alpha: 0.0,
      y: -180
    }, {
      alpha: 1.0,
      y: 0,
      duration: 0.60,
      ease: "power1.inOut"
    });

    this.currentTimeline.fromTo($screenEl.find(".perso-remise"), {
      alpha: 0.0,
    }, {
      alpha: 1.0,
      duration: 0.60,
      ease: "power1.inOut"
    });

    this.currentTimeline.fromTo($screenEl.find(".circle-button"), {
      alpha: 0.0,
      scale: 0.8
    }, {
      alpha: 1.0,
      scale: 1.0,
      duration: 0.60,
      ease: "power1.inOut"
    });
  }

  /**
   * Animate Out Remise Archetype screen
   * @param screenDestinationId
   */
  animateOutRemiseArchetype(screenDestinationId = false) {
    const $screenEl = $("#screen-" + this.currentScreen);

    this.waitingForRFIDScan = false;

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    $screenEl.removeClass("current");

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Hide content
    this.currentTimeline.to($screenEl.find(".container, .bag"), {
      y: 180,
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    });

    // Perso
    this.currentTimeline.to($screenEl.find(".perso-remise"), {
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    }, "<=");

    // Hide circle button
    this.currentTimeline.to($screenEl.find(".circle-button"), {
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    }, "<=");

    this.currentTimeline.add(() => {
      // Allow screen change
      this.unlockCurrentScreen();

      if (screenDestinationId) {
        this.goToScreen(screenDestinationId);
      } else {
        this.goToNextScreen();
      }
    });
  }


  /**
   * Animate In Ending screen
   * @param $screenEl
   */
  animateInEnding($screenEl) {
    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Prevent interaction with screen
    $screenEl.addClass("disabled");

    // Remove archetype
    $("#main").removeClass("archetype-1 archetype-2 archetype-3 archetype-4 archetype-5");

    // Show background
    // this.currentTimeline.fromTo($screenEl.find(".background-overlay"), {
    //   alpha: 0.0
    // }, {
    //   alpha: 1.0,
    //   duration: 0.75,
    //   ease: "power2.inOut"
    // });

    // Show content
    this.currentTimeline.fromTo($screenEl.find(".container"), {
      alpha: 0.0,
      y: -180
    }, {
      alpha: 1.0,
      y: 0,
      duration: 0.60,
      ease: "power1.inOut"
    });
    this.currentTimeline.fromTo($screenEl.find(".container-content"), {
      alpha: 0.0
    }, {
      alpha: 1.0,
      duration: 0.75,
      ease: "power1.inOut"
    });

    this.currentTimeline.set($screenEl.find(".timer-progress circle"), {
      strokeDasharray: 201.062,
      strokeDashoffset: 201.062
    });
    this.currentTimeline.fromTo($screenEl.find(".timer-progress"), {
      alpha: 0.0
    }, {
      alpha: 1.0,
      duration: 0.75,
      ease: "power1.inOut"
    });

    // Enable interaction with screen
    this.currentTimeline.add(() => {
      $screenEl.removeClass("disabled");

      // Reset redirect timeout and start timer
      if (this.endingRedirectTimeout !== false) {
        clearTimeout(this.endingRedirectTimeout);
        this.endingRedirectTimeout = false;
      }
      this.endingScreenTimer.startTimer(
        $screenEl.find(".timer-progress"),
        this.endingRedirectDelay,
        () => {
          this.animateOutReset();
        });
    }, '<=');
  }

  reset(screenId) {
    super.reset(screenId)
    this.archetypeData = {archetype: 5, inventory: []};
  }
}
